import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Paper,
} from '@mui/material';
import ListingRow from './ListingRow';

interface ListingsTableProps {
  listings: any[];
}

const ROWS_PER_PAGE_OPTIONS = [10, 25, 50];

const ListingsTable: React.FC<ListingsTableProps> = ({ listings }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(ROWS_PER_PAGE_OPTIONS[0]);

  // If the list shrinks (refetch, filter, store disconnect) make sure the
  // current page still exists.
  useEffect(() => {
    const lastPage = Math.max(0, Math.ceil(listings.length / rowsPerPage) - 1);
    if (page > lastPage) setPage(lastPage);
  }, [listings.length, rowsPerPage, page]);

  const pagedListings = listings.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Paper>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Image</TableCell>
              <TableCell>Title</TableCell>
              <TableCell>Store</TableCell>
              <TableCell>Vendor</TableCell>
              <TableCell>Product Type</TableCell>
              <TableCell>Price Range</TableCell>
              <TableCell>Inventory</TableCell>
              <TableCell>SKU</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pagedListings.map((listing) => (
              <ListingRow key={listing.id} listing={listing} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={listings.length}
        page={page}
        onPageChange={(_event, newPage) => setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        }}
        rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
      />
    </Paper>
  );
};

export default ListingsTable;
